export default "__VITE_ASSET__BBNOEboT__"